// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HLF0","textarea":"styles_textarea__2cRw3"};